import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FormFieldTags from '../../FormLegacy/FormFieldTags/FormFieldTags'
import api from '../../../api/api'

const MAX_TAGS_COUNT = 50
const MAX_TAG_LENGTH = 50

const TagsSection = ({ tags = [], setEditModeList, setFieldValue, buildingId }) => {
  const { t } = useTranslation(['clients-legacy'])
  const [options, setOptions] = useState([])

  const prepareTags = (tags) =>
    tags.length ? tags.map((tag) => ({ value: tag, label: tag })) : tags

  const fetchBuildingTags = async () => {
    const buildingTags = await api.getBuildingTags(buildingId)
    setOptions(prepareTags(buildingTags))
  }

  useEffect(() => {
    if (buildingId) {
      fetchBuildingTags()
    }
  }, [])

  return (
    <div className={`general-information`}>
      <div className="title">
        {t('clients-legacy:profileView.tags.title', { count: tags.length })}
      </div>
      <div className="information-element">
        <FormFieldTags
          name="tags"
          options={options}
          placeholder={t('clients-legacy:profileView.tags.placeholder')}
          onChange={(_, newTags) => {
            setEditModeList((prev) => [...prev, 'tags'])
            setFieldValue('tags', newTags.length ? newTags.map((tag) => tag.value) : newTags)
          }}
          value={prepareTags(tags)}
          maxTagLength={MAX_TAG_LENGTH}
          maxTagsCount={MAX_TAGS_COUNT}
        />
      </div>
    </div>
  )
}

TagsSection.propTypes = {
  tags: PropTypes.array,
  setEditModeList: PropTypes.func,
  setFieldValue: PropTypes.func,
  buildingId: PropTypes.number,
}

export default TagsSection
